import React from 'react';
import MainViewNav from './MainViewNav';
import MainViewShortBtns from './MainViewShortBtns';
import MainViewCatsSlider from './MainViewCatsSlider';
import MainViewCategories from './MainViewCategories';
import './css/mainview.css';
import { Link } from 'react-router-dom';
const MainView = () => {
  return (
    <section className='main-view'>

            <MainViewNav />
            <MainViewShortBtns />
            <MainViewCatsSlider />
            <MainViewCategories />

    </section>
  )
}

export default MainView